import axios from 'axios'

const cache = {}

export async function getRecords (table, predicate) {
  if (!cache[table]) {
    cache[table] = axios.get(`/data/${table}.json`).then(response => response.data.records)
    cache[table].catch(() => { delete cache[table] })
  }
  const records = await cache[table]
  return { data: { records: predicate ? records.filter(predicate) : records } }
}

export function bySlug (slug) {
  return record => record.fields.slug === slug
}

export function byIds (ids) {
  const wanted = new Set((ids || []).map(String))
  return record => wanted.has(String(record.id))
}
